import { IOptionMenuItem } from '@/dealroom/types/option-menu-item';
import { EnumDocumentType } from '@/enums/DocumentType';

export class CreateDocumentConstants {
  static salesActions: IOptionMenuItem[] = [
    {
      title: EnumDocumentType.Sales,
      icon: 'create-document-sales',
      callback: EnumDocumentType.Sales,
      preventFillIcon: true,
    },
    {
      title: EnumDocumentType.Presentation,
      icon: 'create-document-presentation',
      callback: EnumDocumentType.Introduction,
      preventFillIcon: true,
    },
    {
      title: EnumDocumentType.Hr,
      icon: 'create-document-hr',
      callback: EnumDocumentType.Hr,
      preventFillIcon: true,
    },
    {
      title: EnumDocumentType.Other,
      icon: 'create-document-other',
      callback: EnumDocumentType.Other,
      preventFillIcon: true,
    },
  ];

  static businessActions: IOptionMenuItem[] = [
    {
      title: EnumDocumentType.Contract,
      icon: 'create-document-hr',
      callback: EnumDocumentType.Hr,
      preventFillIcon: true,
    },
    {
      title: EnumDocumentType.Presentation,
      icon: 'create-document-presentation',
      callback: EnumDocumentType.Introduction,
      preventFillIcon: true,
    },

    {
      title: EnumDocumentType.Other,
      icon: 'create-document-other',
      callback: EnumDocumentType.Other,
      preventFillIcon: true,
    },
  ];

  static subMenuSalesActions: IOptionMenuItem[] = [
    {
      title: 'create-document',
      icon: 'create-document-resource',
      callback: 'create-document',
      options: [...CreateDocumentConstants.salesActions],
    },
  ];

  static subMenuBusinessActions: IOptionMenuItem[] = [
    {
      title: 'create-document',
      icon: '',
      callback: 'create-document',
      options: [...CreateDocumentConstants.businessActions],
    },
  ];
}
